(function() { window.GUID_7a07f6dc_d129_4a7e_9683_c1432aadf956 = { getGuid: function() { return "7a07f6dc-d129-4a7e-9683-c1432aadf956"; } }; })();
var bracketMainOptionsMenu = null;
function BindBracketMainOptionsMenu(canvasContentEdge, flowBlockId) {
    var chartInfos = $('#ChartInfos');
    chartInfos.on('click', function () {
        var mainData = {
            flowBlockId: flowBlockId
        };
        /*  CS.Ajax(CSParameters.RUrl + "charts/GetBracketMainOptionsMenu/" + CSParameters.SportEventId, CompuSport.Ajax.AjaxCallType.GET, false, mainData, function (result) {
              var $menu = $(result);
  
              AppendMenuToBody($menu, chartInfos, flowBlockId);
          });*/
    });
}
function AppendMenuToBody(menu, title, flowBlockId) {
    if (bracketMainOptionsMenu != null) {
        bracketMainOptionsMenu.slideUp(function () {
            bracketMainOptionsMenu.remove();
            bracketMainOptionsMenu = null;
        });
        return;
    }
    var offset = title.offset();
    var curtop = 0;
    var obj = title[0];
    if (obj.offsetParent) {
        do {
            curtop += obj.offsetTop + jQuery.css(obj, "borderTopWidth", true);
            obj = obj.offsetParent;
        } while (obj);
    }
    if (offset.top - curtop > 15) {
        offset.top -= CS.win.scrollTop();
    }
    var cssMenu = { top: offset.top + title[0].offsetHeight + 'px' };
    menu.css(cssMenu);
    CS.body.append(menu);
    bracketMainOptionsMenu = menu;
    bracketMainOptionsMenu.slideDown(function () {
        bracketMainOptionsMenu.on('click', '.BracketMainOptionsMenuButton', function (e) {
            var $button = $(this);
            if ($button.hasClass('AddBracketNotes')) {
                BracketMainOptionsAddNotes(flowBlockId);
            }
        });
    });
}
function BracketMainOptionsAddNotes(flowBlockId) {
    //CompuSport.Ajax.Post(url, data, function (result) {
    //    if (refreshChart) {
    //        UpdateChart(result, true);
    //        RefreshPosition(cContentEdge);
    //    }
    //    if (callback != null) {
    //        callback();
    //    }
    //});
}

//# sourceMappingURL=BracketMainOptionsMenu.desktop.js.map
